import React, { useState } from "react";
import SidebarUser from "../components/user/SidebarUser";
import Profile from "../components/user/Profile";
import UserCalendar from "../components/user/UserCalendar";
import UserKarnety from "../components/user/UserKarnety";
import UserTreningi from "../components/user/UserTrening";
import FilesToDownload from "../components/user/FilesToDownload";
import UserPayments from "../components/user/UserPayments";
import Linki from "../components/user/Linki";

const UserPanel = () => {
  const [activeComponent, setActiveComponent] = useState("Dashboard");

  // Function to render the selected component
  const renderComponent = () => {

    switch (activeComponent) {
      case "Profile":
        return <Profile />;
      case "Kalendarz":
        return <UserCalendar />;
      case "Karnety":
        return <UserKarnety />;
      case "Treningi":
        return <UserTreningi />;
      case "Dopobrania":
        return <FilesToDownload />;
      case "Platności":
        return <UserPayments />;
      case "Linki":
        return <Linki />;
      default:
        return <Profile />;
    }
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <SidebarUser setActiveComponent={setActiveComponent} />

      {/* Main content area */}
      <div className="flex-1  bg-gray-100">{renderComponent()}</div>
    </div>
  );
};

export default UserPanel;
